module.exports = __webpack_public_path__ + "static/media/Roboto-Light.c8405cfa.woff";